import { Output, Component, Input, EventEmitter } from "@angular/core";
import { FormControl } from "@angular/forms";

@Component({
  selector: "cowing-checkbox",
  templateUrl: "./cowing-checkbox.component.html",
  styleUrls: ["./cowing-checkbox.component.scss"],
})
export class CowingCheckboxComponent {
  @Input("label") label: string;
  @Input("isForm") isForm: boolean = false;
  @Input("control") control: FormControl = null;
  @Input("value") value: boolean = false;
  @Output("event") onClickEvent = new EventEmitter();

  onClick(event) {
    this.onClickEvent.emit(event);
  }
}
